module.exports = __webpack_public_path__ + "img/208.dirty_urinals.84b12fb8.svg";